<template>
  <div class="swiper-container1">
    <swiper
      ref="listSwiper"
      class="swiper-wrapper swiper-wrapper-n"
      :options="swiperOption"
    >
      <swiper-slide
        class="swiper-slide"
        v-for="(item, index) in items"
        :key="index"
      >
          <div class="sw-card" :class="{'active':active === item.url}" @click='goto(item)'>
            <img class="main-img" :src="item.image" />
            <span>{{item.text}}</span>
          </div>
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import browser from '@/utils/browser'

export default {
  computed: {
    swiper() {
      return this.$refs.listSwiper.$swiper;
    },
    swiperOption() {
      // let that = this
      return {
        slidesPerView: "auto",
        autoplay: false
      };
    },
    items() {
      return this.data;
    }
  },
  data() {
    return {
      showNext: 0,
      showPre: 0,
      isMobile: browser.mobile
    };
  },
  methods: {
    
    goto(item) {
      this.$emit('handleItem',item)
    }
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  props:['active','data'],
  mounted() {
    this.$emit("swiper1", this.swiper);
  },
};
</script>
<style lang="less" scoped>
.swiper-container1 {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 120px;
  background: rgba(0, 0, 0, 0.3);
  .swiper-wrapper {
    background: none;
    width: 100%;
    .swiper-slide {
      transform-style: preserve-3d;
      height: auto!important;
      width: 170px;
      padding: 5px;
      cursor: pointer;
      .sw-card{
        text-align: center;
        font-size: 0;
        border: solid 2px rgba(255, 255, 255, 0.4);
        position: relative;
        border-radius: 16px;
        font-size: 0;
        overflow: hidden;
        margin: 0;
        img {
          width: 100%;
        }
        >span{
          position: absolute;
          bottom: 0;
          left: 0;
          // background: rgba(0, 0, 0, 0.5);
          width: 100%;
          color: #fff;
          padding: 2px 0;
          font-size: 14px;
          text-align: center;
        }
      }
      .active{
          border: solid 2px #E6C78E;
        }
    }
  }
}

</style>
